import React from "react";
import ErrorBoundary from "lib/ErrorBoundary";
import { NotFound } from "pages/login/NotFound";
import { LoadingSpinner } from "lib/Spinner";
import useIsMobile from "lib/hooks/useIsMobile";
import { NotAvailable } from "lib/SimpleTable";
import { titleFromPath } from "app/header/parts/HeaderTitle";
import { getPathname } from "lib/routing";
import { SidePanel } from "pages/redesign/viewLayout/sidePanel/collaspingPanel/SidePanel";
import { PillsBar } from "pages/redesign/viewLayout/toolbar/PillsBarRedesign";
import { useCreateSearchRequest } from "pages/redesign/publications/api/searchRequest/useCreateSearchRequest";
import { useJSFetchPublications } from "pages/redesign/publications/api/direct/useJSFetchPublications";
import { useFetchLandingPage } from "../useFetchLandingPage";
import {
  PocHtmlContent,
  PromotedPublications,
  LandingPublications,
  PocHashtagPublications,
  LandingPageAdverts,
} from "../parts/LandingPageParts";
import styles from "./LandingPage.module.scss";

export function LandingPage({ match }) {
  const [pageData, isLoading, error] = useFetchLandingPage(match.params.topic);
  const searchRequest = useCreateSearchRequest(pageData);
  const searchResults = useJSFetchPublications(searchRequest);

  if (isLoading) return <LoadingSpinner />;
  if (error) return <NotAvailable />;
  if (!pageData) return <NotFound />;
  if (
    pageData.redirect_link !== undefined &&
    pageData.redirect_link !== "" &&
    pageData.redirect_link !== null &&
    window.location.href !== pageData.redirect_link
  ) {
    window.location.href = pageData.redirect_link;
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }
  return <LandingPageView {...pageData} searchResults={searchResults} contentPath="1" />;
}

function getLandingPageFilters(reportFilter, reportFilterParams, title) {
  let landingPageFilters = reportFilterParams?.[1];

  if (reportFilter?.["customData.featured"]) {
    landingPageFilters = landingPageFilters?.replace("true", title);
  }

  return `?${landingPageFilters}`;
}

function LandingPageView({
  html_content,
  reportFilter,
  featuredReportFilter,
  hashtags,
  html_file,
  advert_ids,
  template_style,
  title,
  searchResults,
  report_filter_url: reportFilterUrl,
}) {
  const isMobile = useIsMobile();
  const aggregations = searchResults[3];
  const reportFilterParams = reportFilterUrl?.split("?");
  const landingPageFilters = getLandingPageFilters(reportFilter, reportFilterParams, title);
  const isLoading = searchResults?.[1];

  return (
    <ErrorBoundary>
      <div className={styles.sectionContainer}>
        {!isMobile && <SidePanel aggregations={aggregations} isLoading={isLoading} style={styles.sidePanel} />}
        <section className={`${styles.section} position-relative px-2`}>
          <h2 className={`${styles.title} mb-3`}>{title || titleFromPath(getPathname())}</h2>
          <div
            dangerouslySetInnerHTML={{ __html: html_content }}
            className={`${styles.htmlContent} ${template_style}`}
          />
          <PillsBar persistentContent={landingPageFilters} />
          {html_file && <PocHtmlContent filename={html_file} />}
          {advert_ids && <LandingPageAdverts advertIds={advert_ids} />}
          {featuredReportFilter && <PromotedPublications filter={featuredReportFilter} />}
          {reportFilter && <LandingPublications filter={reportFilter} title={title} searchResults={searchResults} />}
          {hashtags && <PocHashtagPublications hashtags={hashtags} />}
        </section>
      </div>
    </ErrorBoundary>
  );
}
